import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app/App";
import { registerServiceWorker } from "@/offline/register-sw";
// La feuille de KaTeX est chargée ici, une fois : le rendu d'une formule sans
// elle produit des empilements de caractères illisibles plutôt qu'une erreur —
// ça marche, et c'est illisible, ce qui est le pire des deux.
import "katex/dist/katex.min.css";
import "@/styles/base.css";

const root = document.getElementById("root");
if (!root) throw new Error("root introuvable");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
